import { UPDATE_SERVER, UPDATE_USER } from '../constants';

const DEFAULT_STATE = {
  server: null,
  user: null,
};

const SessionReducer = (state = DEFAULT_STATE, { type, payload }) => {
  switch (type) {
    case UPDATE_SERVER:
      return {
        ...state,
        server: payload,
      };
    case UPDATE_USER:
      return {
        ...state,
        user: payload,
      };
    default:
      return state;
  }
};

export default SessionReducer;
